import { getAnonymousID, getSessionID } from 'redline-client-sdk';

import { getAppName } from '@libs/utils/helpers/getAppName';
import { handleRefreshToken, shouldRefreshToken, clearACLocalData } from '@libs/acp/utils/handleRefreshToken';

import { useUserStore } from '@libs/acp/store/user/useUserStore';
import { getLogs } from '@common/helpers/acLogsDB';

export async function addXAuthTokenHeaders(method: any) {
  method.config.headers = method.config.headers || {};
  method.config.headers['X-App-Id'] = getAppName();

	const isCloseAgreement = method?.url.includes('/api/acordo/fechar');
  const logsDB = isCloseAgreement ? await getLogs() : null;

  const authenticatedUser = useUserStore.getState().authenticatedUser;
  let accessToken = authenticatedUser.acp.auth.access_token;
  const refreshToken = authenticatedUser.acp.auth.refresh_token;

  if (!accessToken) {
		if (isCloseAgreement) {
			const logoutTrail = JSON.stringify(logsDB);
			console.error('[customAddHeaders][authProvider][closeAgreement] Zustand was empty', {
				pathname: window.location.pathname,
				timestamp: new Date().toISOString(),
				logoutTrail,
			});
		} else {
			console.error('[customAddHeaders][authProvider] Token is falsy — user may not be authenticated', {
				pathname: window.location.pathname,
				timestamp: new Date().toISOString(),
			});
		}
  }

  if (accessToken) {
    method.config.headers['Accept'] = 'application/json, text/plain, */*';
    method.config.headers['Content-Type'] = 'application/json';

    const shouldRefreshTokenBefore = await shouldRefreshToken();
    if (shouldRefreshTokenBefore) {
      try {
        const response = await handleRefreshToken({ refreshToken: refreshToken || '' });
        if (response?.access_token) {
          accessToken = response.access_token;
        }

      } catch {
        console.error('[customAddHeaders][authProvider] Token refresh failed', {
          pathname: window.location.pathname,
          timestamp: new Date().toISOString(),
        });

        clearACLocalData();
        window.location.href = '/login';
        return Promise.reject(new Error('Token refresh failed'));
      }
    }

    const isEngageSignIn = method?.url === '/v2/engage/signin';
    const isMonitoring = method?.url === '/v2/app/customer/consults';
    const isNegativeDebts = method?.url === '/v2/app/customer/negative-data';
    const isScore = method?.url === '/v2/app/score';
    const isScoreHistory = method?.url === '/v2/app/score/history';

    if (!isEngageSignIn) {
      method.config.headers['X-Auth-Token'] = accessToken;
    }

    if (isMonitoring || isNegativeDebts || isScore || isScoreHistory) {
      method.config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
  }
}

export async function addSessionHeaders(method: any) {
  method.config.headers['x-anonymous-id'] = getAnonymousID();
  method.config.headers['x-session-id'] = getSessionID();
}
